import Repository from "@/services/Repository";
import { SchoolUser } from "../models/People";
import Auth from "../common/firebase.auth";

const resource = "/users";

export default {
  async register({ newUser, newSchool }) {
    let path = "register";
    return Repository.post(`${resource}/${path}`, {
      newUser,
      newSchool
    });
  },
  async registerFirebase({ newUser, newSchool }) {
    let path = "regis";
    return Repository.post(`/auth/${path}`, {
      newUser,
      newSchool
    });
  },
  async importUsers({ newUsers }) {
    let path = "import";
    return Repository.post(`${resource}/${path}`, {
      newUsers
    });
  },
  async add(newUser) {
    return Repository.post(`${resource}/`, {
      newUser
    });
  },
  async update(changedEntry) {
    return Repository.put(`${resource}/${changedEntry.id}`, {
      changedEntry
    });
  },
  async delete(userId) {
    return Repository.delete(`${resource}/${userId}`);
  },
  async getUserInfo() {
    let authId = Auth.currentUser.uid;
    return Repository.get(`${resource}/user-info/${authId}`);
  },
  async login(credential) {
    let path = "authenticate";
    return Repository.post(`${resource}/${path}`, credential);
  },
  async fetch() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}`)
        .then(response => {
          const { data } = response;
          const users = data.map(userData => new SchoolUser(userData));
          resolve(users);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
